import React, { useId } from 'react';
import BaseModal from './BaseModal';
import BottomSheet from '../../student/BottomSheet';
import useIsCoachMobile from '../../../hooks/useIsCoachMobile';

/**
 * BaseModal on the desktop, bottom sheet on the coach phone (< 768 px): the
 * same title, content and footer. Desktop props (size, zIndex, className…) go
 * to BaseModal untouched; `sheetZ` sets the sheet's stacking class (a sheet
 * opened from another one passes a higher one).
 */
const SheetOrModal = ({ isOpen, onClose, title, titleIcon, footer, headerActions, children, sheetZ = 'z-[90]', ...modalProps }) => {
  const isPhone = useIsCoachMobile();
  const titleId = useId();

  if (isPhone) {
    return (
      <BottomSheet isOpen={!!isOpen} onClose={onClose} labelledBy={titleId} zClassName={sheetZ} expandable>
        <div className="flex max-h-[85dvh] flex-col [[data-sheet-resized]_&]:max-h-none">
          {title && (
            <div className="flex items-center gap-3 px-5 pb-3 pt-1">
              <h2 id={titleId} className="flex min-w-0 flex-1 items-center gap-2 text-[17px] font-bold text-white">
                {titleIcon && <span className="flex shrink-0 text-kaiylo-accent">{titleIcon}</span>}
                <span className="min-w-0">{title}</span>
              </h2>
              {/* Actions de l'en-tête (ex. corbeille d'un jalon), à droite du titre. */}
              {isOpen && headerActions && <div className="flex shrink-0 items-center [&_svg]:h-5 [&_svg]:w-5">{headerActions}</div>}
            </div>
          )}
          <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-5 pb-2">{isOpen && children}</div>
          {isOpen && footer && <div className="px-5 pt-2">{footer}</div>}
        </div>
      </BottomSheet>
    );
  }

  return (
    <BaseModal isOpen={isOpen} onClose={onClose} title={title} titleIcon={titleIcon} footer={footer} headerActions={headerActions} {...modalProps}>
      {children}
    </BaseModal>
  );
};

export default SheetOrModal;
